import { render, staticRenderFns } from "./finance.vue?vue&type=template&id=46748d36&scoped=true"
import script from "./finance.vue?vue&type=script&lang=js"
export * from "./finance.vue?vue&type=script&lang=js"
import style0 from "./finance.vue?vue&type=style&index=0&id=46748d36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46748d36",
  null
  
)

export default component.exports